import { useCallback, useEffect } from 'react';
import analyticsService from '../services/analyticsService';

export const usePortalTracking = () => {
  // Track portal session
  useEffect(() => {
    const sessionStart = Date.now();
    analyticsService.trackPortalEngagement({
      action: 'session_start',
      timestamp: new Date()
    });

    return () => {
      const duration = Date.now() - sessionStart;
      analyticsService.trackPortalEngagement({
        action: 'session_end',
        duration,
        timestamp: new Date()
      });
    };
  }, []);

  const trackPortalAction = useCallback((actionData) => {
    analyticsService.trackPortalEngagement({
      ...actionData,
      timestamp: new Date()
    });
  }, []);

  const trackDocumentAccess = useCallback((documentData) => {
    analyticsService.trackPortalEngagement({
      action: 'document_access',
      ...documentData,
      timestamp: new Date()
    });
  }, []);

  const trackReportView = useCallback((reportData) => {
    analyticsService.trackPortalEngagement({
      action: 'report_view',
      ...reportData,
      timestamp: new Date()
    });
  }, []);

  return {
    trackPortalAction,
    trackDocumentAccess,
    trackReportView
  };
}; 